import {NgModule} from '@angular/core';
import {PlaceInfoService} from './place-info.service';

/**
 * Created by Rodrigo Quesada on 28/02/17.
 */
@NgModule({
    providers: [PlaceInfoService]
})
export class PlaceInfoModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/place/place-info.module.ts